import dimensions from "./dimensions";

const isHamburg = false;

export { dimensions, isHamburg };

